<template>
    <div class="relative">
        <div
            class="rounded-lg bg-white p-4 shadow dark:bg-slate-800"
            :class="processing ? 'pointer-events-none opacity-50' : ''"
        >
            <div class="flex flex-wrap items-center justify-between gap-4 border-b border-gray-100 pb-3 dark:border-slate-700">
                <div>
                    <h3 class="text-base font-semibold text-gray-900 dark:text-slate-100">
                        Checklist Antifraude
                    </h3>
                    <p class="text-xs text-gray-500 dark:text-slate-400">
                        Valide os pontos críticos antes de decidir pelo saque.
                    </p>
                </div>
                <span class="rounded-full bg-indigo-50 px-3 py-1 text-xs font-semibold text-indigo-600 dark:bg-indigo-900/40 dark:text-indigo-200">
                    {{ completedCount }}/{{ totalCount }} verificados
                </span>
            </div>

            <div v-if="totalCount" class="mt-4 space-y-3">
                <div
                    v-for="item in items"
                    :key="item.id"
                    class="flex cursor-pointer items-start gap-3 rounded-lg border border-gray-100 px-3 py-2 transition hover:border-indigo-200 dark:border-slate-700 dark:hover:border-slate-500"
                    @click="handleToggle(item.id)"
                >
                    <input
                        type="checkbox"
                        :checked="item.checked"
                        @click.stop="handleToggle(item.id)"
                        class="mt-1 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    <div class="flex flex-1 flex-col">
                        <div class="flex items-start gap-2">
                            <span class="text-sm font-medium text-gray-900 dark:text-slate-100">
                                {{ item.label }}
                            </span>
                            <span
                                v-if="item.severity"
                                :class="severityClass(item.severity)"
                            >
                                {{ severityLabel(item.severity) }}
                            </span>
                        </div>
                        <span class="text-xs text-gray-500 dark:text-slate-400">
                            {{ item.description }}
                        </span>
                    </div>
                </div>
            </div>

            <div v-else class="mt-4 text-sm text-gray-500 dark:text-slate-400">
                Carregando itens para validação...
            </div>

            <div class="mt-4 flex flex-wrap justify-end gap-2 border-t border-gray-100 pt-3 dark:border-slate-700">
                <button
                    class="rounded-md border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 transition hover:border-gray-300 hover:text-gray-800 dark:border-slate-600 dark:text-slate-300 dark:hover:border-slate-500 dark:hover:text-slate-100"
                    @click="$emit('reset')"
                >
                    Reiniciar checklist
                </button>
                <button
                    class="rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
                    :disabled="disableReject"
                    @click="$emit('reject')"
                >
                    Reprovar
                </button>
                <button
                    class="rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-60"
                    :disabled="disableApprove"
                    @click="$emit('approve')"
                >
                    Aprovar
                </button>
            </div>
        </div>
        <div
            v-if="processing"
            class="pointer-events-none absolute inset-0 flex items-center justify-center rounded-lg bg-white/80 dark:bg-slate-800/80"
        >
            <ticto-loading size="sm" />
        </div>
    </div>
</template>

<script>
import TictoLoading from "../../layouts/TictoLoading.vue";

export default {
    name: "FraudChecklist",
    components: {
        TictoLoading,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        completedCount: {
            type: Number,
            default: 0,
        },
        disableApprove: {
            type: Boolean,
            default: false,
        },
        disableReject: {
            type: Boolean,
            default: false,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        totalCount() {
            return this.items.length;
        },
    },
    methods: {
        handleToggle(itemId) {
            if (this.processing) {
                return;
            }

            this.$emit("toggle", itemId);
        },
        severityClass(severity) {
            switch (severity) {
                case "danger":
                    return "ml-auto rounded bg-red-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-700 dark:bg-red-900/40 dark:text-red-300";
                case "warning":
                    return "ml-auto rounded bg-yellow-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300";
                default:
                    return "";
            }
        },
        severityLabel(severity) {
            switch (severity) {
                case "danger":
                    return "Atenção";
                case "warning":
                    return "Revisar";
                default:
                    return "";
            }
        },
    },
};
</script>
